import * as React from 'react';
import cn from '~modules/cn';
import Styles from './radio.module.scss';

export type RadioType = 'negative';

type Props = {
    type?: RadioType;
} & React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

const Radio = React.forwardRef<HTMLInputElement, Props>(
    ({ className, type, ...rest }, ref): JSX.Element => (
        <input {...rest} type="radio" ref={ref} className={cn(Styles.radio, className, { [Styles[`radio-type-${type}`]]: type })} />
    )
);

Radio.displayName = 'Radio';

export default Radio;
